<template>
  <div>
    <div class="content-7">
      <header-detail @complete="reload" />
      <trend-tabbar @change-component="changeComponent" />
    </div>
    <div class="content-8">
      <transition name="tab" mode="out-in">
        <component :is="currentComponent" ref="KaiJiang" />
      </transition>
    </div>
  </div>
</template>

<script>
// header
import HeaderDetail from '@/components/desktop/pages/trend/HeaderDetail'
import TrendTabbar from '@/components/desktop/pages/trend/TrendTabbar'

// 綜合類
import KaiJiangHaoMa from '@/components/desktop/pages/trend/KaiJiangHaoMa'
import ReMenHaoMaTongJi from '@/components/desktop/pages/trend/ReMenHaoMaTongJi'
import YiLouHaoMaTongJi from '@/components/desktop/pages/trend/YiLouHaoMaTongJi'
import ReMenShengXiaoTongJi from '@/components/desktop/pages/trend/ReMenShengXiaoTongJi'
import YiLouShengXiaoTongJi from '@/components/desktop/pages/trend/YiLouShengXiaoTongJi'

// 路珠類
import DanShuangLuJhu from '@/components/desktop/pages/trend/DanShuangLuJhu'
import DaXiaoLuJhu from '@/components/desktop/pages/trend/DaXiaoLuJhu'
import BoSeLuJhu from '@/components/desktop/pages/trend/BoSeLuJhu'
import ZongHeDanShuangLuZhu from '@/components/desktop/pages/trend/ZongHeDanShuangLuZhu'
import ZongHeDaXiaoLuZhu from '@/components/desktop/pages/trend/ZongHeDaXiaoLuZhu'
import WeiShuDaXiaoLuZhu from '@/components/desktop/pages/trend/WeiShuDaXiaoLuZhu'
import HeShuDanShuangLuZhu from '@/components/desktop/pages/trend/HeShuDanShuangLuZhu'

// 走勢類
import ZhengMaZouShi from '@/components/desktop/pages/trend/ZhengMaZouShi'
import TeMaZouShi from '@/components/desktop/pages/trend/TeMaZouShi'
import ShengXiaoZouShi from '@/components/desktop/pages/trend/ShengXiaoZouShi'
import JiaQinYeShouZouShi from '@/components/desktop/pages/trend/JiaQinYeShouZouShi'
import NanNuShengXiaoZouShi from '@/components/desktop/pages/trend/NanNuShengXiaoZouShi'
import TianDiShengXiaoZouShi from '@/components/desktop/pages/trend/TianDiShengXiaoZouShi'
import SiJiShengXiaoZouShi from '@/components/desktop/pages/trend/SiJiShengXiaoZouShi'
import QinQiShuHuaZouShi from '@/components/desktop/pages/trend/QinQiShuHuaZouShi'
import SanSeShengXiaoZouShi from '@/components/desktop/pages/trend/SanSeShengXiaoZouShi'

export default {
  name: 'WebLotteryTrend',
  transition: 'layout',
  components: {
    HeaderDetail,
    TrendTabbar,

    // 綜合類
    KaiJiangHaoMa,
    ReMenHaoMaTongJi,
    YiLouHaoMaTongJi,
    ReMenShengXiaoTongJi,
    YiLouShengXiaoTongJi,

    // 路珠類
    DanShuangLuJhu,
    DaXiaoLuJhu,
    BoSeLuJhu,
    ZongHeDanShuangLuZhu,
    ZongHeDaXiaoLuZhu,
    WeiShuDaXiaoLuZhu,
    HeShuDanShuangLuZhu,

    // 走勢類
    ZhengMaZouShi,
    TeMaZouShi,
    ShengXiaoZouShi,
    JiaQinYeShouZouShi,
    NanNuShengXiaoZouShi,
    TianDiShengXiaoZouShi,
    SiJiShengXiaoZouShi,
    QinQiShuHuaZouShi,
    SanSeShengXiaoZouShi
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,
      currentComponent: null
    }
  },
  methods: {
    changeComponent(componentName) {
      this.currentComponent = componentName
    },
    reload() {
      // 這個 function 用來重整開獎頁面的下方資料
      const { KaiJiang: midComponent } = this.$refs
      if (!midComponent) return
      const { name } = midComponent.$options
      // KaiJiangHaoMa 直接掛在 KaiJiang ref 上，不需往下找子層
      if (name === 'KaiJiangHaoMa') {
        if (typeof midComponent.getTableList !== 'function') return
        midComponent.getTableList()
        return
      }
      // 透過 component name 判斷：如果中間層組件不是即時開獎或歷史開獎就不重整
      if (name !== 'JiShihKaiJiang' && name !== 'LiShihKaiJiang') return
      const { KaiJiangTable: kaiJiangComponent } = midComponent.$refs
      if (!kaiJiangComponent) return
      if (typeof kaiJiangComponent.getTableList !== 'function') {
        console.warn('走勢頁面：reload function沒有找到對應的子層function做呼叫, 無法執行 reload, ', kaiJiangComponent.getTableList)
        return
      }
      kaiJiangComponent.getTableList()
    }
  }
}
</script>

<style lang="scss" scoped>

// element loading 位置調整
/deep/ {
  .el-loading-spinner {
    top: 100px;
    color: #2990ff;

    &::after {
      content: '努力加载中';
      position: absolute;
      left: 46.8%;
      top: 120%;
    }
  }
}

</style>
